import React from "react";
import { useQuery } from "@apollo/client";
import { listConformiteCorrectives } from "../../../../graphql/queries";
import { Segment, Button } from "semantic-ui-react";
import DisplayLoading from "../../../../components/common/DisplayLoading";
import DisplayError from "../../../../components/common/DisplayError";
import CorrectiveDetail from "../include/CorrectiveDetail";

const ConformiteAdd2 = ({ next, prev }) => {
  const { data, loading, error } = useQuery(listConformiteCorrectives, {
    fetchPolicy: "network-only",
  });

  return (
    <Segment.Group>
      <DisplayLoading loadingMessage={loading} iconName="circle notched" />
      <DisplayError errorMessage={error} />
      <CorrectiveDetail data={data} />
      <Segment textAlign="center">
        <Button.Group>
          <Button
            onClick={prev}
            fluid
            to="#"
            type="submit"
            floated="right"
            content="Precedent"
          />
          <Button.Or text="OU" />
          <Button
            fluid
            type="submit"
            floated="right"
            positive
            content="Suivant"
            onClick={next}
          />
        </Button.Group>
      </Segment>
    </Segment.Group>
  );
};

export default ConformiteAdd2;
